module.exports = __webpack_public_path__ + "img/邮件预览背景.fd34e6f6.png";